import { storeFrontApiClient } from '../apiClient'
import { getActualProductQuantityQuery } from './getActualProductQuantityQuery'
import { getRelatedProductsQuery } from './getRelatedProductsQuery'
import {getBonusProductsQuery} from "./getBonusProductsQuery";
import {getProductsQuery} from "./getProductsQuery";

const getNodesByIds = async (ids, query) => {
  try {
    const response = await storeFrontApiClient
      .request(query, {
        variables: {
          ids,
        },
      })
      .catch((e) => {
        console.log('catch ===', e)
      })

    return response.data
  } catch (e) {
    console.error('Error fetching product', e)
  }
}

const getRelatedProductsByIds = async (ids) => {
  try {
    const response = await getNodesByIds(ids, getRelatedProductsQuery)

    return response.nodes
  } catch (e) {
    console.error('Error fetching product', e)
  }
}

const getBonusProductsByIds = async (ids) => {
  try {
    const response = await getNodesByIds(ids, getBonusProductsQuery)

    return response.nodes
  } catch (e) {
    console.error('Error fetching product', e)
  }
}

const getActualProductQuantity = async (ids) => {
  try {
    const response = await getNodesByIds(ids, getActualProductQuantityQuery)

    return response.nodes
  } catch (e) {
    console.error('Error fetching product', e)
  }
}

const getProducts = async (query, sort, reverse, after) => {
  try {
    const response = await storeFrontApiClient
      .request(getProductsQuery, {
        variables: {
          query,
          sort,
          reverse,
          after
        },
      })

    return response.data
  } catch (e) {
    console.error('Error fetching product', e)
    throw e;
  }
}

export default {
  getNodesByIds,
  getRelatedProductsByIds,
  getActualProductQuantity,
  getBonusProductsByIds,
  getProducts
}
